var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTriangleAttention = function SvgTriangleAttention(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.04 5.26a1.926 1.926 0 0 1 2.623.7l.002.003 10.072 17.445a1.925 1.925 0 0 1-1.664 2.891H22.642a1 1 0 1 1 0-2h3.3L15.999 7.077 6.057 24.3h8.942V22.16a1 1 0 1 1 2 0v3.14a1 1 0 0 1-1 1H5.926a1.926 1.926 0 0 1-1.665-2.891L14.333 5.963l.002-.004c.17-.29.412-.532.704-.7Z",
    fill: "#102B3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 10.867a1 1 0 0 1 1 1v5.97a1 1 0 1 1-2 0v-5.97a1 1 0 0 1 1-1Z",
    fill: "#102B3F"
  })));
};
export default SvgTriangleAttention;